import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';
import { fontSize } from 'src/assets/fonts-config';
import { fontWeight } from 'src/assets/fonts-config';
import { RemoveTrashIcon } from 'src/assets/icons/RemoveTrashIcon';
import { Checkbox } from 'src/components/Checkbox/Checkbox';

interface LiveNotificationListItemType {
    imgSrc?: string;
    isDisabled: boolean;
}

type ImageContainerType = Pick<LiveNotificationListItemType, 'imgSrc'>;

export const ImageContainer = styled('div', { label: 'ImageContainer' })<ImageContainerType>`
    ${({ imgSrc }): string => imgSrc === undefined ? '' : `background-image: url(${imgSrc})`};
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 100px;
    max-width: 120px;
    width: 100%;
`;

export const ContentContainer = styled('div', { label: 'ContentContainer' })`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 32px;
    width: 100%;
`;

export const CampaignName = styled('div', { label: 'CampaignName' })`
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    color: ${mainColors.main.primary};
`;

export const TrashIconWrapper = styled(RemoveTrashIcon, { label: 'TrashIconWrapper' })`
    cursor: pointer;
    margin-left: 8px;
`;

export const ActiveLabel = styled('span', { label: 'ActiveLabel' })`
    color: ${lpPageColors.activeLabel};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin: 0 0 10px 8px;
`;

export const CheckboxWrapper = styled(Checkbox, { label: 'CheckboxWrapper' })`
    margin-bottom: 12px;
`;

export const ActiveLabelSmall = styled(ActiveLabel, { label: 'ActiveLabelSmall' })`
    display: block;
    font-size: 10px;
    line-height: 1;
    font-weight: ${fontWeight.regular};
`;

